import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { TableModule } from "primeng/table";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "jni-customer-address",
  templateUrl: "./customer-address.component.html",
  styleUrls: ["./customer-address.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    ReactiveFormsModule,
    ModalStackerComponent,
    InputTextModule,
  ],
})
export class CustomerAddressComponent {
  @Input() parent!: FormGroup;
  clientDisplayModal = false;
  clientId = "";

  redirectToClientSummary() {
    this.clientId = this.parent.get(["orderHeader", "customerId"])?.value;
    const name = this.parent.get(["customerAddress", "name"])?.value;
    const address = this.parent.get(["customerAddress", "address"])?.value;
    if ((name && this.clientId) || (address && this.clientId)) {
      this.clientDisplayModal = true;
    }
  }

  closeModal() {
    this.clientDisplayModal = false;
  }
}
